// extracted by mini-css-extract-plugin
module.exports = {"price":"f2","currency":"f3","strikethrough":"f4","secondary":"f5"};